import React, { Component } from 'react'
import { MDBDataTable } from "mdbreact";

import { Row, Col, Container, Alert } from "reactstrap";

import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getInfoUrl } from '../../helpers/url';

//import uploadedFileInfoUrl from "../../helpers/url"

export default class FileUploadedInfo extends Component {
    constructor() {
        super()
        this.state = {
            error: false,
            errorMsg: "",
            breadcrumbItems : [
                { title : "UTJD", link : "/dashboard" },
                { title : "Uploaded Files", link : "/fileUploadedInfo" },
            ],
            data: {
                columns: [
                    {
                        label: "Category",
                        field: "category",
                        sort: "asc",
                        width: 100
                    },
                    {
                        label: "Comment",
                        field: "comment",
                        sort: "asc",
                        width: 100
                    },
                    {
                        label: "Description",
                        field: "description",
                        sort: "asc",
                        width: 150
                    },
                    {
                        label: "S3 Location",
                        field: "s3location",
                        sort: "asc",
                        width: 80
                    },
                    {
                        label: "URL",
                        field: "url",
                        sort: "asc",
                        width: 70
                    },
                    {
                        label: "Date",
                        field: "registeredDate",
                        sort: "asc",
                        width: 50
                    }
                ],
            rows: [
            ],
            }
        }
    }
    
    componentDidMount() {
        const jwt = JSON.parse(sessionStorage.getItem("authUser"))
        const accessToken = jwt.jwtToken
        fetch(getInfoUrl, {
            method: "GET",
            headers: {"Content-Type": "application/json", "Authorization": accessToken}
        })
        .then(res=>res.json())
        .then((data) => {
            if(data.message) {
                this.setState({
                    error: true,
                    errorMsg: data.message + ". Please relogin!"
                })
            } 
            var tableRows = {...this.state.data}
            tableRows.rows = data
            this.setState({
                data: tableRows
            })
        })
        .catch(err => {
            console.log("error", err)
            this.setState({
                error: true,
                errorMsg: err.message
            })
        })
    }

    render() {
        if (this.state.error === true) {
            return(
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Uploaded Files" breadcrumbItems={this.state.breadcrumbItems} />
                            <div className="mt-5 text-center">
                                <Alert id="error" color="error" isOpen={this.state.error} toggle={this.responseHandling}>
                                {this.state.errorMsg}
                                </Alert>
                            </div> 
                        </Container>
                    </div>
                </React.Fragment>
            )
        }
        
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Uploaded Files" breadcrumbItems={this.state.breadcrumbItems} />
                        <Row>
                            <Col xs={12}>
                                <MDBDataTable responsive hover bordered data={this.state.data} />
                            </Col>
                        </Row>
                         
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
